module.exports = __webpack_public_path__ + "static/img/scene10.6f178cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scene10.png
// module id = Xkk0
// module chunks = 1